module.exports = __webpack_public_path__ + "img/success.7786d18d.png";